<template>
  <div style="padding:.5rem;border:1px solid black">
    <p style="padding:.5rem;text-align: center;margin:5px 0 ;font-size: .5rem;font-weight: bold">{{info.Title}}</p><br/>
    <span style="white-space: pre-wrap;" v-html="info.Text"></span>
  </div>
</template>

<script>
export default {
  name: 'articleDetail',
  data () {
    return {
      info: {}
    }
  },
  components: {},
  methods: {
    getArticleDetail(){
      const params = {
        Id: this.$route.query.Id
      }
      this.$post('/BizMemberRegion/Details',params).then(res => {
        if (res) {
          this.info = res.Data.BizContractInfo
        }
      })
    }
  },
  mounted () {
    this.getArticleDetail()
  }
}
</script>

<style lang="less">
  .articleDetail{
    img{
      max-width: 100%;
    }
  }
</style>
